import {FieldSelect, FieldTag, FormSection} from "../../../ui";

interface CmsStorageConfigurationFormData {
    storageCabinets: string[]
    storageWarehouseId: string
}

interface CmsStorageConfigurationFormHelp {
    storageCabinets?: string
    storageWarehouseId?: string,
}

interface SelectOption {
    value: string;
    label: string;
}

interface CmsStorageConfigurationFormProps {
    value: CmsStorageConfigurationFormData
    storageWarehouseOption: SelectOption[]
    onChange: (value: CmsStorageConfigurationFormData) => any
    validate: () => Promise<any>
    saving: boolean
    help: CmsStorageConfigurationFormHelp
}

const CmsStorageConfigurationForm = function CmsStorageConfigurationForm({
                                                                             storageWarehouseOption,
                                                                             value,
                                                                             saving,
                                                                             onChange,
                                                                             validate,
                                                                             help
                                                                         }: CmsStorageConfigurationFormProps) {

    return <FormSection
        label={"Einlagerung"}>
        <>
            <div className={"columns"}>
                <div className={"column is-one-third"}>
                    <FieldSelect
                        label={"Lagerstandort"}
                        disabled={saving}
                        invalid={Boolean(help.storageWarehouseId)}
                        help={help.storageWarehouseId}
                        options={storageWarehouseOption}
                        value={value.storageWarehouseId}
                        onBlur={async () => await validate()}
                        onChange={v => {
                            onChange({
                                ...value,
                                storageWarehouseId: v
                            })
                        }}
                        required={true}
                    />
                </div>
                <div className="column is-one-third">
                    <FieldTag
                        label={"Schränke"}
                        required={true}
                        disabled={saving}
                        onBlur={async () => await validate()}
                        help={help.storageCabinets}
                        invalid={Boolean(help.storageCabinets)}
                        value={value.storageCabinets}
                        createTagOnEnter={true}
                        onChange={v => {
                            onChange({
                                ...value,
                                storageCabinets: v
                            })
                            validate().finally()
                        }}
                        inputTransform={v => v.toUpperCase().replace(/[\W_ ]+/g, "")}
                    />
                </div>
            </div>
        </>
    </FormSection>
}

export {
    CmsStorageConfigurationForm
}
